export default "__VITE_ASSET__CjZ56iS0__"